import gameState from "slotworks/model/game-state";
import GatewayResult, { GatewayType } from "model/gameplay/records/results/gateway-result";

export default function isAfterGatewayMC() {
    const record = gameState.getCurrentGame().getRootRecord();
    const gatewayMC = record.getResultsOfType(GatewayResult)[0];

    if (!gatewayMC) {
        return false;
    }

    const isGatewayMC = gatewayMC.gatewayType === GatewayType.MC_BONUS;
    const gatewayMCIsPlayed = gatewayMC.played;
    return isGatewayMC && gatewayMCIsPlayed;
}
